import './respiAllerGrading/register';
import './respiAllerPrickTestMeasurements/register';
import './respiAllerQuestionnaire/register';
import './respiAllerQuestionnaireStatus/register';
import './respiAllerReferral/register';
import './respiAllerResendQuestionnaire/register';
